module.exports = __webpack_public_path__ + "static/media/Swimming Champion.e8129294.jpg";